import { Input, InputProps } from 'antd';
import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';
import {
  InputComponentWrapper,
  InputComponentWrapperProps,
} from 'baseComponents/InputComponentWrapper';
import './styles.scss';

type PasswordInputComponentProps = InputProps &
  Pick<
    InputComponentWrapperProps,
    'error' | 'description' | 'fullWidth' | 'label'
  >;

export const PasswordInputComponent = ({
  error,
  description,
  label,
  fullWidth,
  ...rest
}: PasswordInputComponentProps) => (
  <InputComponentWrapper {...{ error, description, label, fullWidth }}>
    <Input.Password
      placeholder='input password'
      className='pj-input'
      status={error ? 'error' : ''}
      {...rest}
      iconRender={(visible) =>
        visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
      }
    />
  </InputComponentWrapper>
);
